// extracted by mini-css-extract-plugin
export var cardIcon = "_9v-4";
export var checkboxCard = "_9v-0";
export var checkboxCardSelected = "_9v-1";
export var disabled = "_9v-2";
export var outerBorder = "_9v-3";
export var spacerMedium = "_9v-7";
export var spacerSmall = "_9v-6";
export var spacerXsmall = "_9v-5";